import styled from "styled-components";

export const DeliveryCheckoutSummaryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .summary-section {
    background: #fff;
    border-radius: 0.625rem;
    box-shadow: 4px 8px 12px 0 rgba(180, 180, 180, 0.2);
    overflow: hidden;
  }

  .summary-section-header {
    display: flex;
    align-items: center;
    gap: 0.625rem;
    padding: 1rem 1.25rem 0.75rem;
    border-bottom: 1px solid #f0f1f3;

    .section-icon {
      font-size: 1.375rem;
      color: #3e434e;
      flex-shrink: 0;
    }

    h3 {
      margin: 0;
      font-size: 1rem;
      font-weight: 600;
      color: #24272e;
    }

    .section-subtitle {
      margin: 2px 0 0;
      font-size: 0.75rem;
      color: #6b7280;
      font-weight: 400;
    }
  }

  .summary-section-header-text {
    display: flex;
    flex-direction: column;
  }

  .address-route {
    display: flex;
    gap: 0.75rem;
    padding: 1rem 1.25rem;
  }

  .address-route-line {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 0.375rem;

    .dot {
      width: 0.5rem;
      height: 0.5rem;
      border-radius: 50%;
      background: #9ca3af;
      flex-shrink: 0;
    }

    .connector {
      width: 1px;
      flex: 1;
      min-height: 48px;
      background: #d1d5db;
      margin: 0.25rem 0;
    }
  }

  .address-cards {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }

  .address-card {
    .address-card-label {
      font-size: 0.75rem;
      font-weight: 600;
      color: #5d606f;
      margin: 0 0 0.25rem;
    }

    .address-card-value {
      margin: 0;
      font-size: 0.875rem;
      color: #24272e;
      line-height: 1.4;
    }
  }

  .info-row {
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    padding: 0.875rem 1.25rem;
    border-bottom: 1px solid #f0f1f3;

    &:last-child {
      border-bottom: none;
    }

    .row-icon {
      font-size: 1.25rem;
      color: #3e434e;
      flex-shrink: 0;
      margin-top: 0.125rem;
    }

    .row-content {
      flex: 1;
      min-width: 0;
    }

    .row-label {
      margin: 0 0 0.25rem;
      font-size: 0.75rem;
      font-weight: 600;
      color: #5d606f;
    }

    .row-value {
      margin: 0;
      font-size: 0.875rem;
      color: #24272e;
      line-height: 1.4;
      word-break: break-word;
    }

    .row-value-secondary {
      margin: 0.25rem 0 0;
      font-size: 0.75rem;
      color: #6b7280;
    }
  }

  .cost-rows {
    padding: 0.5rem 1.25rem 1rem;
  }

  .cost-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem 0;
    font-size: 0.875rem;

    &.total {
      font-weight: 600;
      font-size: 0.9375rem;
      padding-top: 0.75rem;
      margin-top: 0.25rem;
      border-top: 1px solid #f0f1f3;
    }

    .cost-label {
      color: #5d606f;
    }

    .cost-value {
      color: #24272e;
    }
  }

  .linked-order-badge {
    display: inline-block;
    margin-bottom: 1rem;
    padding: 0.375rem 0.75rem;
    border-radius: 0.375rem;
    background: #eef2ff;
    color: #4f46e5;
    font-size: 0.8125rem;
    font-weight: 500;
  }
`;
